import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Dr. Sayuja Clinic',
    description: 'Dental clinic management for Dr. Sayuja Clinic: patients, visit history, appointments, prescriptions, billing, follow-ups and WhatsApp reminders in one place.',
    placeholder: 'Dental clinic management for Dr. Sayuja Clinic.',
    url: getOrigin()
}
